export default {
  en: {
    CALL_LOGS_DELETE_SUCCESS: 'Report settings deleted successfully',
    CALL_LOGS_SAVE_SUCCESS: 'Report settings saved successfully',
    CALL_LOGS_UPDATE_SUCCESS: 'Report settings updated successfully',
    CALL_LOGS_DUPLICATE_SUCCESS: 'Report settings duplicated successfully',
    DEFAULT_CALL_LOGS_TITLE: 'Reporting'
  }
};
